/*******************************************************************************
 * Dependency Imports
 ******************************************************************************/

// Helpers
import { getEndpoint } from '@lib/helpers'
import axios from 'axios'

/*******************************************************************************
 * Private methods
 ******************************************************************************/

/*******************************************************************************
 * Public methods
 ******************************************************************************/

/**
 * grab a single check by id
 * @returns
 */
export const show = async check_id => {
    return new Promise(( resolve, reject ) => {

        if (!check_id) {
            return reject({ mesage: 'check_id is missing' })
        }

        axios({
            method: 'get',
            url: getEndpoint('/check/'+check_id, []),
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * update a single check by id
 * @returns
 */
export const update = async (check_id, data = {}) => {
    return new Promise(( resolve, reject ) => {

        if (!check_id) {
            return reject({ mesage: 'check_id is missing' })
        }

        axios({
            method: 'patch',
            url: getEndpoint('/check/'+check_id, []),
            data,
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * delete a single check by id
 * @returns
 */
export const deleteCheck = async check_id => {
    return new Promise(( resolve, reject ) => {

        if (!check_id) {
            return reject({ mesage: 'check_id is missing' })
        }
        axios({
            method: 'delete',
            url: getEndpoint('/check/'+check_id, []),
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * grab all the checks for a single asset
 * @returns
 */
export const listForAsset = async (asset_id, params = []) => {
    return new Promise(( resolve, reject ) => {

        if (!asset_id) {
            return reject({ mesage: 'asset_id is missing' })
        }

        axios({
            method: 'get',
            url: getEndpoint('/asset/'+asset_id+'/checks', params),
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * create a check for an asset
 * @returns
 */
export const createForAsset = async (asset_id, data = {}) => {
    return new Promise(( resolve, reject ) => {

        if (!asset_id) {
            return reject({ mesage: 'asset_id is missing' })
        }

        axios({
            method: 'post',
            url: getEndpoint('/asset/'+asset_id+'/check', []),
            data,
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}